import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Button from '@spothero/ui/button';
import DateUtils from 'utils/date';
import CancellationInfo from 'common/cancellation-info/CancellationInfo';
import Card from 'common/card/Card';
import PaymentMethodsIcons from 'common/payment-methods-icons/PaymentMethodsIcons';
import Price from 'common/price/Price';
import AvailableInventory from './AvailableInventory';

export default class AirportPurchaseInformation extends Component {
    static propTypes = {
        facility: PropTypes.object,
        isFetchingRates: PropTypes.bool,
        starts: PropTypes.string,
        ends: PropTypes.string,
        availableTransientInventory: PropTypes.number,
        selectedRate: PropTypes.object,
        fetchRates: PropTypes.func.isRequired,
        onCheckoutClick: PropTypes.func,
        pushTo: PropTypes.func,
        updateSelectedSpot: PropTypes.func,
        displayPrice: PropTypes.number,
        currencyType: PropTypes.string,
        onShowConfirmDateTimeModal: PropTypes.func,
    };

    constructor(props) {
        super(props);

        const {isFetchingRates} = props;

        this.state = {
            prevIsFetchingRates: isFetchingRates,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {isFetchingRates} = nextProps;

        if (prevState.prevIsFetchingRates && !isFetchingRates) {
            return {
                prevIsFetchingRates: isFetchingRates,
            };
        }

        return null;
    }

    _onDateTimeSearchClick = ({starts, ends}) => {
        const {facility, fetchRates} = this.props;
        const {id: spotId} = facility;

        fetchRates({
            spotId,
            starts,
            ends,
            airport: true,
            meta: {
                dateTimeChanged: true,
            },
        });
    };

    _onDateTimeEditClick = () => {
        const {onShowConfirmDateTimeModal} = this.props;

        onShowConfirmDateTimeModal(true);
    };

    _onViewOtherOptionsClick = () => {
        const {
            facility: {
                airport: {
                    details: {url},
                },
            },
            starts,
            ends,
            pushTo,
            updateSelectedSpot,
        } = this.props;
        let searchUrl = `/${url}`;

        if (starts && ends) {
            searchUrl += `?airport=true&starts=${starts}&ends=${ends}`;
        }

        updateSelectedSpot();
        pushTo(searchUrl);
    };

    render() {
        const {
            facility: {cancellation_allowed: cancellationAllowed},
            starts,
            ends,
            selectedRate,
            availableTransientInventory,
            onCheckoutClick,
            displayPrice,
            currencyType,
        } = this.props;
        const dateTimeFormatted = DateUtils.getDateTimeSummary({
            startDateTimeObj: moment(starts),
            endDateTimeObj: moment(ends),
            isMonthly: false,
        });

        return (
            <Card className="AirportPurchaseInformation">
                <div className="AirportPurchaseInformation-reservation-time">
                    <div className="title">
                        <h2 className="title-heading">
                            <span>Reservation Time</span>
                        </h2>
                        <Button
                            className="title-action"
                            onClick={this._onDateTimeEditClick}
                        >
                            Edit
                        </Button>
                    </div>
                    <div className="preview-datetime">{dateTimeFormatted}</div>
                </div>
                <AvailableInventory
                    availableTransientInventory={availableTransientInventory}
                />
                {selectedRate && (
                    <div className="AirportPurchaseInformation-daily-price">
                        <span className="price-per-day">
                            <Price
                                amount={displayPrice}
                                currencyType={currencyType}
                            />{' '}
                            <span className="per-day">Per Day</span>
                        </span>
                        <small className="price-basis">
                            Price is based on a 24 hour period
                        </small>
                    </div>
                )}
                <Button
                    className="AirportPurchaseInformation-book-now"
                    color="primary"
                    disabled={!selectedRate}
                    onClick={onCheckoutClick}
                    block
                >
                    Book Now
                </Button>
                <PaymentMethodsIcons showAppleAndGooglePay />
                <CancellationInfo
                    className="AirportPurchaseInformation-no-cancellation"
                    cancellationAllowed={cancellationAllowed}
                    showFreeCancellation
                />
            </Card>
        );
    }
}
